import Select from "kreate-common/modules/kreate-ui/components/Select";
import { GetArtworkList$Params } from "kreate-server/commands/GetArtworkList/typing";
import * as React from "react";
import { z } from "zod";

export const ArtworkOrder = z.enum([
  "newest",
  "most_popular",
  "minting_price_desc",
  "minting_price_asc",
  "most_recently_loved",
  "most_recently_commented",
]);

export type ArtworkOrder = z.infer<typeof ArtworkOrder>;

type ArtworkOrderItems = {
  [name in ArtworkOrder]: {
    label: React.ReactNode;
    orderBy: GetArtworkList$Params["orderBy"];
    orderDirection: GetArtworkList$Params["orderDirection"];
  };
};

export const artworkOrderItems: ArtworkOrderItems = {
  newest: {
    label: "Last Updated",
    orderBy: "last_updated",
    orderDirection: "desc",
  },
  most_popular: {
    label: "Most Loved",
    orderBy: "popular",
    orderDirection: "desc",
  },
  most_recently_loved: {
    label: "Recently Loved",
    orderBy: "recently_loved",
    orderDirection: "desc",
  },
  most_recently_commented: {
    label: "Recently Commented",
    orderBy: "recently_commented",
    orderDirection: "desc",
  },
  minting_price_asc: {
    label: "Price: Low to High",
    orderBy: "minting_price",
    orderDirection: "asc",
  },
  minting_price_desc: {
    label: "Price: High to Low",
    orderBy: "minting_price",
    orderDirection: "desc",
  },
};

type Props = {
  className?: string;
  style?: React.CSSProperties;
  value: ArtworkOrder;
  onChange: (value: ArtworkOrder) => void;
  disabled?: boolean;
};

export default function Select$ArtworkOrder({
  className,
  style,
  value,
  onChange,
  disabled,
}: Props) {
  return (
    <div className={className} style={style}>
      <Select
        options={Object.entries(artworkOrderItems).map(
          ([value, { label }]) => ({
            label,
            value: value as ArtworkOrder,
            // NOTE: Object.entries always return `string` for the key parameter.
            // However in this case its type has to be ArtworkOrder
          })
        )}
        minButtonWidth="160px"
        minContentWidth="240px"
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
}
